import { Stack } from "@mui/system";
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";
import NegativeFilterItems from "./NegativeFilterItems";
import {
  setOpenBulkActionModal,
  setSelectedNegativeSearchTerm,
  setSingleRowIDPassToModal,
} from "../../../../../../../../../../features/scopesTabSlice";
import BulkActionModal from "./BulkActionModal";
import { useSearchParams } from "react-router-dom";
function NegativeSearchAdgroupFilterCard() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    negativesInListAndInAdGroupData,
    selectedNegativeSearchTerm,
    openBulkActionModal,
    selectedRowsForNegatives,
  } = useSelector((state: any) => state.searchTermOperation);

  //close bulk action modal
  const handleClose = () => {
    dispatch(setOpenBulkActionModal(false));
    dispatch(setSingleRowIDPassToModal(""));
  };

  const clearSelectedSearchTerm = () => {
    dispatch(setSelectedNegativeSearchTerm(null));
  };

  const searchOptions = useMemo(() => {
    const set = new Set<string>();
    (negativesInListAndInAdGroupData || []).forEach((r: any) => {
      if (typeof r?.search_term === "string") set.add(r.search_term.trim());
    });
    return Array.from(set); // ["shoes", "hats", ...]
  }, [negativesInListAndInAdGroupData]);

  //-- this hold search params in url
  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    dispatch(setSelectedNegativeSearchTerm(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Paper sx={{ padding: "8px 16px", marginTop: "8px", boxShadow: "none" }}>
        <Stack
          flexDirection={"row"}
          justifyContent={"start"}
          gap={2}
          // sx={{ padding: "16px 16px 0px 16px" }}
        >
          <Autocomplete
            fullWidth
            disablePortal
            data-tracker="136"
            sx={{ width: "390px" }}
            options={searchOptions}
            value={selectedNegativeSearchTerm || null} // string or null
            onChange={(_, newValue: string | null) => {
              dispatch(setSelectedNegativeSearchTerm(newValue ?? ""));
              setSearchParams((prevParams) => {
                const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
                if (newValue) {
                  updatedParams.search = newValue; // Set new value
                  updatedParams.page = "0";
                } else {
                  delete updatedParams.search; // Remove from URL if cleared
                }
                return updatedParams;
              });
            }}
            getOptionLabel={(opt) => opt || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Term"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          />
          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            sx={{ width: "100%" }}
          >
            <NegativeFilterItems
              clearSelectedSearchTerm={clearSelectedSearchTerm}
            />
            {/* --- Bulk Actions Header --- */}
            <Stack flexDirection="row" gap={1} justifyContent="space-between">
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography variant="body1">Bulk Actions:</Typography>
                <Tooltip title="Remove NST From Adgroup">
                  <IconButton
                    color={
                      selectedRowsForNegatives?.length > 0 ? "error" : "default"
                    }
                    size="small"
                    disabled={selectedRowsForNegatives?.length === 0}
                    onClick={() => {
                      dispatch(setOpenBulkActionModal(true)); //modal open
                      dispatch(setSingleRowIDPassToModal("")); //single row id empty when bulk action
                    }}
                  >
                    <RemoveCircleOutlinedIcon
                      data-tracker="504"
                      fontSize="medium"
                    />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>
          </Stack>
          {/* Bulk Action Dialog */}
          <BulkActionModal open={openBulkActionModal} onClose={handleClose} />
        </Stack>
      </Paper>
    </>
  );
}
export default NegativeSearchAdgroupFilterCard;
